(function () {
    var FORM_SELECTOR = '.product-card__form, .ecom-featured__form';

    function getRoot() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    function updateCartDrawer() {
      import('@theme/events').then(({ CartUpdateEvent }) => {
      const cartDrawer = document.querySelector('cart-drawer-component');    
      fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const event = new CartUpdateEvent(cart, 'manual-trigger', {
          itemCount: cart.item_count,
          source: 'fad-refresh',
          sections: {}
        });
        document.dispatchEvent(event);
          cartDrawer.open();

        
      });
    });
    }

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.matches(FORM_SELECTOR)) return;

      event.preventDefault();

      var formData = new FormData(form);
      var root = getRoot();

      fetch(root + 'cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'X-Shopify-Requested-With': 'XMLHttpRequest'
        }
      })
        .then(function (response) {
          if (!response.ok) throw response;
          return response.json();
        })
        .then(function () {
          updateCartDrawer();
        })
        .catch(function (error) {
          console.error('AJAX add to cart failed, fallback to normal submit', error);
          form.submit();
        });
    });
  })();